import React from "react";
import Container from "../Common/Container";
import RowContainer from "../Common/RowContainer";
import Particles from "../Common/ParticleDesign";

interface ColumnData {
  name: string;
  particleType: string;
  particleValue: string;
  particleType1: string;
  particleValue1: string | null;
}

interface ConjugationItem {
  id: number;
  oneListId: number;
  value1?: string;
  value2?: string;
  value3?: string;
  column1?: ColumnData;
  column2?: ColumnData;
  column3?: ColumnData;
}

interface ConjugationListData {
  id: number;
  flashCardContentComponentId?: number;
  isC1Visible: boolean;
  isC2Visible: boolean;
  isC3Visible: boolean;
  lightTheme: string;
  conjugationList?: ConjugationItem[];
}

interface ConjugationListProps {
  data: ConjugationListData;
  onClick?: () => void;
}

/**
 * Flutter logic:
 *   lightTheme == "Light" → bg #110929, text white
 *   else (dark)           → bg transparent, text #16162F
 */
const ConjugationList: React.FC<ConjugationListProps> = ({ data, onClick }) => {
  const { isC1Visible, isC2Visible, isC3Visible, lightTheme, conjugationList } = data;

  const isLight = lightTheme === "Light";
  const bgColor = isLight ? "#110929" : "transparent";
  const textColor = isLight ? "#FFFFFF" : "#16162F";

  return (
    <Container
      bgColor={bgColor}
      color={textColor}
      borderRadius="24px"
      padding="12px 16px"
      width="100%"
      cursor="pointer"
      onClick={onClick}
    >
      <RowContainer flexDirection="column">
        {conjugationList &&
          conjugationList.map((item) => (
            <RowContainer
              key={item.id}
              alignItem="center"
              justifyContent="space-between"
            >
              {isC1Visible && (
                <Particles
                  text={[item.value1 ?? "", item.column1?.particleValue1 ?? ""]}
                  type={[item.column1?.particleType ?? "", item.column1?.particleType1 ?? ""]}
                  textColor={item.column1?.particleType === "Text" ? textColor : undefined}
                />
              )}
              {isC2Visible && (
                <Particles
                  text={[item.value2 ?? "", item.column2?.particleValue1 ?? ""]}
                  type={[item.column2?.particleType ?? "", item.column2?.particleType1 ?? ""]}
                  textColor={item.column2?.particleType === "Text" ? textColor : undefined}
                />
              )}
              {isC3Visible && (
                <Particles
                  text={[item.value3 ?? "", item.column3?.particleValue1 ?? ""]}
                  type={[item.column3?.particleType ?? "", item.column3?.particleType1 ?? ""]}
                  textColor={item.column3?.particleType === "Text" ? textColor : undefined}
                />
              )}
            </RowContainer>
          ))}
      </RowContainer>
    </Container>
  );
};

export default ConjugationList;
